module.exports = __webpack_public_path__ + "static/media/Formoplast_2018_doklad DVI.64eac05f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2019/Formoplast_2018_doklad DVI.pdf
// module id = 127
// module chunks = 0